export const SUBSCRIPTION_TERMS_PATH = '/subscription/conditions';

export const SUBSCRIPTION_ROOT_PATH = '/subscription';
